import { Component, OnInit, ViewChild } from '@angular/core';
import { Job } from '../domain/job';
import { JobsService } from '../services/jobs.service';
import { ResourcesService } from '../services/resource.service';
import { Message, SelectItem } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import { MultiSelect } from 'primeng/multiselect';

import { Router } from '@angular/router';
import * as _ from 'underscore';

import {
  CSS_FAILED,
  CSS_OK,
  CSS_WARNING,
  JOB_DEFINITION_PAGE,
  SharedDataService,
  STATUS_COMPLETE,
  STATUS_FAILED,
  STATUS_FORECAST,
  STATUS_HOLD,
  STATUS_MESSAGE_WAITING,
  STATUS_RUNNING
} from '../services/shared-data.service';
import { StorageService } from '../services/storage.service';
import { ArticleService } from '../services/article.service';
import { Article } from '../domain/article';
import { Table } from 'primeng/table';
import moment from 'moment-timezone';
import { DatePipe } from '@angular/common';
import { AuthenticationGuard } from '../oauth/authentication.guard';
import { ViewLog } from '../domain/ViewLog';
import { selectedRowDetails } from '../domain/selectedRowDetails';
import { ViewLogsComponent } from '../view-logs/view-logs.component';
import { MatDialog } from '@angular/material/dialog';
import { InsertJob } from '../domain/InsertJob';


@Component({
  selector: 'app-jobs-table',
  templateUrl: './robot-dashboard.component.html',
  styleUrls: ['./robot-dashboard.component.css'],
  standalone: false
})
export class RobotDashboardComponent implements OnInit {


  jobs: Job[];
  csvJobs: Job[];
  application: string;
  location: string;
  resource: string;
  viewlog: ViewLog;
  selectedRowData: selectedRowDetails;
  applications: SelectItem[];
  jobNames: SelectItem[];
  locations: string[];
  locationsDropDown: SelectItem[];
  resources: SelectItem[];
  statusOptions: SelectItem[];
  data: string[];
  msgs: Message[] = [];
  isFilterApp: boolean;
  selectedJob: Job;
  filters: string;

  // to block/unblock
  locationsBlock = true;
  enableButtons = true;
  loading = false;
  totalRecords: number;
  selectedFilters = false;
  filtersApplied: string;

  //Pages Default
  page = 0;
  size = 10;
  sort = false;

  //Sort
  sortOrder: string;
  sortField: string;

  counterLower: number;
  counterHigher: number;
  counter100: number;
  graphicHidden: boolean;
  labels: string[];
  jobEndedOk: number[];
  jobNotOk: number[];
  jobRunning: number[];
  i: number;
  idToken;
  article: Article;
  displayHelp: any;
  cols: any[];

  csvCols: any[];

  selectedLocation: string;
  selectedAppFullName: string[];
  selectedJobName: string;
  selectedDescription: string;
  selectedStatus: string[];
  selectedStartDate: Date;

  @ViewChild(('dt'), { static: true }) dtTable: Table;
  @ViewChild('ms', { static: false }) multiselect: MultiSelect;
  @ViewChild('ms2', { static: false }) multiselectTwo: MultiSelect;
  @ViewChild('dd', { static: true }) locationDropDown: Dropdown;
  firstOnTable: any;
  display: boolean = false;
  loadingExport: boolean = true;
  totalPages: number;
  showJobLogDialogue: boolean = false;


  constructor(private readonly jobsService: JobsService, private readonly resourcesService: ResourcesService,
              private readonly router: Router, private readonly sharedDataService: SharedDataService,
              private readonly storageService: StorageService,
              private readonly authorizationService: AuthenticationGuard,
              private readonly articleService: ArticleService, private readonly datePipe: DatePipe, public readonly dialog: MatDialog) {
    this.isFilterApp = true;
    this.filters = 'Show Filters';
    if (this.sharedDataService.resource) {
      setTimeout(() => {
        this.selectedStatus = [];
        this.restoreTable();
        this.sharedDataService.insertJobData(null);
      });
    }
  }

  ngOnInit() {

    this.authorizationService.checkLogin();
    this.selectedAppFullName = [];
    this.selectedLocation = null;
    this.selectedJobName = null;
    this.selectedDescription = null;
    this.selectedStatus = [];
    this.selectedStartDate = null;
    this.graphicHidden = false;
    this.resources = [];
    this.labels = [];
    this.getResources();
    this.counter100 = 0;
    this.counterHigher = 0;
    this.counterLower = 0;
    this.jobEndedOk = [];
    this.jobNotOk = [];
    this.jobRunning = [];
    this.jobs = [];
    this.displayHelp = false;
    this.article = { text: '', title: '' };
    this.selectedRowData = { selectedStartDate: null, selectedJobName: '', selectedAppFullName: [], selectedLocation: '', selectedStatus: [], selectedDescription: '', resource: '' }
    this.viewlog = { dataLog: null, jobDetails: '', rowData: null, selectedRowDetail: this.selectedRowData };

    // Columns used for table display
    this.cols = [
      { field: 'entry', header: 'Entry', width: '7%' },
      { field: 'jobName', header: 'Job Name', width: '6%' },
      { field: 'status', header: 'Status', width: '5%' },
      { field: 'start', header: 'Local Time (UTC)', width: '5%' },
      { field: 'percentage', header: 'Duration (Avg%)', width: '5%' }
    ];

    // Columns used for CVS single page export
    this.csvCols = [
      { field: 'application', header: 'Application' },
      { field: 'location', header: 'Location' },
      { field: 'jobName', header: 'Name' },
      { field: 'description', header: 'Description' },
      { field: 'status', header: 'Status' },
      { field: 'startTimestampUtc', header: 'Date and Time UTC' },
      { field: 'startTimestamp', header: 'Date and Time' },
      { field: 'endTimestampUtc', header: 'End Time' },
      { field: 'averageTime' + 'seconds', header: 'Average Time' }
    ];
  }

  // -----------------------------------  Loading Table -----------------------------------------------------

  // Dynamic function for Job table
  loadJobsLazy(event: any) {

    this.selectedFilters = false;
    this.graphicHidden = false;
    // Get Jobs once the resource is selected
    if (this.resource != null && this.selectedLocation != null) {
      this.loading = true;
      // Save event for restoring and table refresh
      this.sortFilters(event);
      this.getJobs(event);
      this.sharedDataService.tableEvent = event;
      this.calculatePercentage();
    }
    // Solves mutiselect glitch
    if (this.multiselect) {
      this.resetMultiselect();
    }

  }

  // GET JOBS LIST
  getJobs(event) {
    //set page and size
    this.page = (event.first / event.rows);

    setTimeout(() => {
      try {
        //Check if filters are being applied
        this.checkFilters(event);
        // WHEN  Filters or Sorting is applied
        this.jobCall(this.page, event.rows, false);
      } catch (error) {
        // Guard against any synchronous error (e.g. stale/invalid filter state
        // left over from a previous Location/filter selection) so the table
        // never gets stuck showing the loading spinner forever.
        console.error('Error building job request', error);
        this.jobs = [];
        this.totalRecords = 0;
        this.loading = false;
      } finally {
        // loading graphics
        this.graphicHidden = false;
        this.enableButtons = false;
      }
    });
  }

  jobCall(page: number, rows: number, csv: boolean) {
    if (this.selectedFilters || this.sort) {
      // set URL for filter
      let filter = 'page=' + page + '&size=' + rows.toString();

      switch (this.sort) {
        case (true):
          filter = 'order=' + this.sortOrder + '&' + filter + this.filtersApplied + '&sort=' + this.sortField;
          break;
        // case (this.sort && !this.selectedFilters):
        //   filter = "order=" + this.sortOrder + "&" + filter + this.filtersApplied + "&sort=" + this.sortField;
        //   break;
        case (false):
          filter = filter + this.filtersApplied;
          break;
      }


      this.jobsService.getFilteredJobs(this.resource, this.selectedLocation.replace(' ', '_'), filter).subscribe({
        next: jobs => {
          this.totalRecords = jobs['totalElements'];
          this.totalPages = Math.ceil((this.totalRecords / this.dtTable.rows));
          if (csv == true) {
            this.csvJobs = jobs['content'];
            this.download();
          } else {
            this.jobs = jobs['content'];
          }

          this.loading = false;
        },
        error: error => {
          console.error('Error retrieving filtered jobs' + error);
          this.jobs = [];
          this.totalRecords = 0;
          this.loading = false;
        }
      });
    } else {
      // NO sorting OR filters Applied
      (this.selectedLocation != 'All') ? this.loadAllLocationJobs(page, rows, csv) : this.loadSelectedResourceLocationJobs(page, rows, csv);

    }

  }

  loadAllLocationJobs(page: number, rows: number, csv: boolean) {
    this.jobsService.getLocationJobs(this.resource, this.selectedLocation.replace(' ', '_'), page.toString(), rows.toString()).subscribe({
      next: jobs => {
        this.totalRecords = jobs['totalElements'];
        this.totalPages = Math.ceil((this.totalRecords / this.dtTable.rows));
        if (csv == true) {
          this.csvJobs = jobs['content'];
          this.download();
        } else {
          this.jobs = jobs['content'];
        }
        this.loading = false;
      },
      error: error => {
        console.error('Error retrieving location jobs' + error);
        this.jobs = [];
        this.totalRecords = 0;
        this.loading = false;
      }
    });
  }

  loadSelectedResourceLocationJobs(page: number, rows: number, csv: boolean) {
    this.jobsService.getJobsPage(this.resource, page.toString(), rows.toString()).subscribe({
      next: jobs => {
        this.totalRecords = jobs['totalElements'];
        this.totalPages = Math.ceil((this.totalRecords / this.dtTable.rows));
        if (csv == true) {
          this.csvJobs = jobs['content'];
          this.download();
        } else {
          this.jobs = jobs['content'];
        }
        this.loading = false;
      },
      error: error => {
        console.error('Error retrieving resource location jobs' + error);
        this.jobs = [];
        this.totalRecords = 0;
        this.loading = false;
      }
    });
  }

  sortFilters(event: any): void {
    this.sort = false;
    if (event.sortField != null) {
      this.sort = true;
      if (event.sortOrder == 1) {
        this.sortOrder = 'ASC';
      } else if (event.sortOrder == -1) {
        this.sortOrder = 'DESC';
      }
      switch (event.sortField) {
        case 'start':
          this.sortField = 'startTimestampUtc';
          break;
        case 'percentage':
          this.sortField = 'runTime';
          break;
        case 'entry':
        case 'jobName':
          this.sortField = 'jobName';
          break;
        case 'status':
          this.sortField = 'status';
          break;
      }
    }
  }


  checkFilters(event: any): void {
    this.selectedFilters = false;
    // Add location to filter
    if (this.selectedLocation != 'All') {
      this.filtersApplied = '&search=location¡' + this.selectedLocation.replace(' ', '_') + ',';
    } else {
      this.filtersApplied = '&search=';
    }
    // Sort order
    if (event.filters['application'] && event.filters['application']['value'] && event.filters['application']['value'].length > 0) {
      this.selectedFilters = true;
      this.filtersApplied += 'application¡';
      event.filters['application']['value'].forEach(job => {
        this.filtersApplied += job.replace(' ', '_') + ';';
      });
      this.nextFilter(this.filtersApplied);
    } else if (this.selectedAppFullName != undefined && this.selectedAppFullName.length > 0) {
      // in case of restored table
      this.selectedFilters = true;
      this.filtersApplied += 'application¡';
      this.selectedAppFullName.forEach(app => {
        this.filtersApplied += app.replace(' ', '_') + ';';
      });
      this.nextFilter(this.filtersApplied);
    }
    if (event.filters['jobName'] && event.filters['jobName']['value']) {
      this.selectedFilters = true;
      this.filtersApplied += 'jobName:';
      let jobName = event.filters['jobName']['value']
      this.filtersApplied += jobName.toString().toUpperCase().replace(' ', '_') + ';';
      this.nextFilter(this.filtersApplied);
    } else if (this.selectedJobName != undefined && this.selectedJobName.length > 0) {
      // in case of restored table
      this.selectedFilters = true;
      this.filtersApplied += 'jobName¡';
      this.filtersApplied += this.selectedJobName.toString().toUpperCase().replace(' ', '_') + ';';
      this.nextFilter(this.filtersApplied);
    }

    if (event.filters['status'] && event.filters['status']['value'] && event.filters['status']['value'].length > 0) {
      this.selectedFilters = true;
      this.filtersApplied += 'status¡';
      event.filters['status']['value'].forEach(job => {
        this.filtersApplied += job.trim().replace(' ', '_') + ';';
      });
      this.nextFilter(this.filtersApplied);
    } else if (this.selectedStatus.length > 0) {
      // in case of restored table
      this.selectedFilters = true;
      this.filtersApplied += 'status¡';
      this.selectedStatus.forEach(status => {
        this.filtersApplied += status.trim().replace(' ', '_') + ';';
      });
      this.nextFilter(this.filtersApplied);
    }

    if (event.filters['startTimestampUtc'] && event.filters['startTimestampUtc']['value']) {
      this.selectedFilters = true;
      let date = this.datePipe.transform(this.getDate(event.filters['startTimestampUtc']['value']), 'yyyy/MM/dd').toString().replace('/', '_');
      this.filtersApplied += 'startTimestampUtc~' + date.replace('/', '_') + ',';
    } else if (this.selectedStartDate != null) {
      // restored table
      this.selectedFilters = true;
      let date = this.datePipe.transform(this.getDate(this.selectedStartDate), 'yyyy/MM/dd').toString().replace('/', '_');

      this.filtersApplied += 'startTimestampUtc~' + date.replace('/', '_') + ',';

    }
    // Clean end of URL for call to endpoint
    let last = this.filtersApplied.substr(this.filtersApplied.length - 1);
    if (last == ';' || last == ',') {
      this.filtersApplied = this.filtersApplied.slice(0, this.filtersApplied.length - 1);

    }
  }


  nextFilter(filters: string) {
    this.filtersApplied = filters.slice(0, this.filtersApplied.length - 1);
    this.filtersApplied += ',';
  }

  getDate(date: Date) {
    let newDate = moment(date);
    return newDate.format('YYYY/MM/DD');
  }


  // ------------------------------   Get Lists for filters  -----------------------------------------------

  listStatus(): void {
    this.statusOptions = [];
    if (this.selectedLocation != 'All') {
      this.jobsService.getFilterStatus(this.resource, this.selectedLocation.replace(' ', '_')).subscribe(statusList => {
        statusList.forEach(status => {
          this.statusOptions.push({ label: status, value: status });
        });
      });
    } else {
      this.jobsService.getAllStatus(this.resource).subscribe(statusList => {
        statusList.forEach(status => {
          this.statusOptions.push({ label: status, value: status });
        });
      });
    }
  }


  listApplications(): void {
    setTimeout(() => {
      this.applications = [];
      if (this.selectedLocation != 'All') {
        this.jobsService.getFilterApps(this.resource, this.selectedLocation.replace(' ', '_')).subscribe(apps => {
          apps.forEach(app => {
            if (!this.applications.includes({ label: app, value: app })) {
              this.applications.push({ label: app, value: app });
            }
          });
        });
      } else {
        this.jobsService.getAllApps(this.resource).subscribe(apps => {
          apps.forEach(app => {
            if (!this.applications.includes({ label: app, value: app })) {
              this.applications.push({ label: app, value: app });
            }
          });
        });
      }

    });
  }

  listJobNames(): void {
    setTimeout(() => {
      this.jobNames = [];
      if (this.selectedLocation != 'All') {
        this.jobsService.getFilterJobNames(this.resource, this.selectedLocation.replace(' ', '_')).subscribe(jobNames => {
          jobNames.forEach(app => {
            if (!this.jobNames.includes({ label: app, value: app })) {
              this.jobNames.push({ label: app, value: app });
            }
          });
        });
      } else {
        this.jobsService.getAllJobNames(this.resource).subscribe(jobNames => {
          jobNames.forEach(jobName => {
            if (!this.jobNames.includes({ label: jobName, value: jobName })) {
              this.jobNames.push({ label: jobName, value: jobName });
            }
          });
        });
      }

    });
  }


  listLocations(): void {
    this.locationsDropDown = [];
    this.jobsService.getLocations(this.resource)
      .subscribe(locations => {
        this.locationsDropDown = locations.map((item) => ({label: item, value: item }));
        this.locationsBlock = false;
        this.locationsDropDown.push({ label: 'All', value: 'All' });
      });

  }


  getResources(): void {
    this.idToken = this.storageService.getItem('encodedAccessToken');
    setTimeout(() => {
      this.resourcesService.getResources(this.idToken)
        .subscribe(resources => {
            this.data = resources;
          },
          error => {
            console.error('Error retrieving resource systems' + error);
            this.resources.push({ label: 'AS400-AAA', value: 'AS400-AAA' });
            // In case authError the AAA data is retrieved
          }, () => {
            this.resources = this.data.map((item) => ({label: item, value: item }));
            this.resources = _.sortBy(this.resources, 'label');
          });
    });

  }

  resourceSelected(dt) {
    this.jobs = [];
    if (dt) {
      dt.reset();
      this.onReloadTable(dt);
    }
    this.loading = true;
    this.loading = false;
    this.enableButtons = true;
    this.locationsBlock = true;
    this.listLocations();
  }

  // resets everything when another resource is selected
  onReloadTable(dt) {
    if (this.resource != null) {
      //Clear filters
      this.selectedAppFullName = null;
      this.selectedLocation = null;
      this.selectedJobName = null;
      this.selectedDescription = null;
      this.selectedStatus = null;
      this.selectedStartDate = null;
      this.sharedDataService.job = null;
      this.locationsDropDown = null;
    } else {
      this.msgs.push({ severity: 'error', summary: 'Info Message', detail: 'No resource selected' });
    }
  }


  filterLocation(dt) {
    // Reset values BEFORE resetting/reloading the table so the lazy-load
    // request triggered by dtTable.reset() below never runs against stale
    // filter selections (e.g. app/job name/status/date) left over from the
    // previously selected Location. Running with stale filters was causing
    // the jobs request to fail/throw and leave the table stuck loading.
    this.selectedAppFullName = null;
    this.selectedJobName = null;
    this.selectedDescription = null;
    this.selectedStatus = [];
    this.selectedStartDate = null;
    this.sharedDataService.job = null;
    if (dt) {
      this.dtTable.reset();
    }
    // Show the filters panel (was previously being toggled back to hidden
    // by an extra call to onFilterButtonClick() right after being set here)
    this.isFilterApp = false;
    this.filters = 'Hide Filters';
    if (this.multiselect) {
      this.multiselect.ngOnInit();
      this.multiselectTwo.ngOnInit();
    }
    this.enableButtons = true;
    this.listApplications();
    this.listJobNames();
    this.listStatus();
    this.enableButtons = false;
  }

  // Show hide buttons
  onFilterButtonClick() {
    if (this.isFilterApp) {
      this.isFilterApp = false;
      this.filters = 'Hide Filters';
    } else {
      this.isFilterApp = true;
      this.filters = 'Show Filters';
    }
  }

  //Go to job details
  goDetails(selectedJob: any): void {
    this.sharedDataService.setJob(selectedJob, this.resource);
    const iJob: InsertJob = new InsertJob(this.resource, selectedJob.id, this.selectedAppFullName, this.selectedLocation,
      this.selectedJobName, this.selectedDescription, this.selectedStatus, this.selectedStartDate);
    this.sharedDataService.insertJobData(iJob);
    this.router.navigate([JOB_DEFINITION_PAGE]);
  }
  showJobLogs(rowData): void {
    this.selectedRowData = { selectedStartDate: null, selectedJobName: '', selectedAppFullName: [], selectedLocation: '', selectedStatus: [], selectedDescription: '', resource: '' }
    this.viewlog = { dataLog: null, jobDetails: '', rowData: null, selectedRowDetail: this.selectedRowData };
    let jobDetails = "QPADEV0017" + "/" + "488627" + "/" + "VMAREEDU";
    this.loading = true;
    this.jobsService.getJobLogs(jobDetails).subscribe(jobLogs => {
      this.loading = false;
      this.viewlog.dataLog = jobLogs;
      this.viewlog.jobDetails = jobDetails;
      this.viewlog.rowData = rowData;
      this.viewlog.selectedRowDetail.selectedStartDate = this.selectedStartDate;
      this.viewlog.selectedRowDetail.selectedStatus = this.selectedStatus;
      this.viewlog.selectedRowDetail.selectedDescription = this.selectedDescription;
      this.viewlog.selectedRowDetail.selectedJobName = this.selectedJobName;
      this.viewlog.selectedRowDetail.selectedLocation = this.selectedLocation;
      this.viewlog.selectedRowDetail.selectedAppFullName = this.selectedAppFullName;
      this.viewlog.selectedRowDetail.resource = this.resource;
      this.dialog.open(ViewLogsComponent, {
        width: '80%',
        height: '70%',
        data: this.viewlog,
      });
      this.loading = false;

    });
  }
  date_1: string[];
  date_2: string[];

  test(startTimeStamp: Date): boolean {
    let date = moment(startTimeStamp).format('DD/MM/YY - HH:mm:ss');
    let date2 = moment().format('DD/MM/YY - HH:mm:ss');

    if (moment(date2, "DD/MM/YYYY HH:mm:ss").isSameOrAfter(moment(date, "DD/MM/YYYY HH:mm:ss"))) {
      return true;
    } else {
      return false;
    }
  }


  // -------------------------------------------- CALCULATIONS -----------------------------------

  calculatePercentage(): void {
    this.jobs.forEach(job => {
        if (job.status !== STATUS_FORECAST) {
          if ((+job.runTime) - (+job.averageTime) < 0) {
            this.counterLower = this.counterLower + 1;
          } else if ((+job.runTime) - (+job.averageTime) > 0) {
            this.counterHigher = this.counterHigher + 1;
          } else {
            this.counter100 = this.counter100 + 1;
          }
        }
      }
    );
  }

  statusHandler(status: string): string {
    if (status.indexOf(STATUS_COMPLETE) >= 0 || status.indexOf(STATUS_FORECAST) >= 0) {
      return CSS_OK;
    } else if (status.indexOf(STATUS_FAILED) >= 0 || status.indexOf(STATUS_MESSAGE_WAITING) >= 0) {
      return CSS_FAILED;
    } else if (status.indexOf(STATUS_RUNNING) >= 0) {
      return CSS_WARNING;
    }
  }

  statusIconHandler(status: string): string {
    if (status.indexOf(STATUS_COMPLETE) >= 0) {
      return 'fa fa-check';
    } else if (status.indexOf(STATUS_FAILED) >= 0 || status.indexOf(STATUS_HOLD) >= 0
      || status.indexOf(STATUS_MESSAGE_WAITING) >= 0) {
      return 'fa fa-close';
    } else if (status.indexOf(STATUS_RUNNING) >= 0) {
      return 'fa fa-spinner';
    } else if (status.indexOf(STATUS_FORECAST) >= 0) {
      return 'fa fa-calendar';
    } else {
      return 'fa fa-warning';
    }
  }


  calculateDeviation(status: string, runtime: string, averageTime: string, percentage: number): string {
    if (status === STATUS_RUNNING || status === STATUS_FORECAST) {
      return '--';
    } else {
      if (Number(averageTime) == 0) {
        percentage = 0;
      } else {
        percentage = Number(runtime) / Number(averageTime) * 100;
      }
      if (percentage % 1 == 0) {
        return runtime + ' / ' + averageTime + ' (' + percentage.toFixed(0) + ')';
      } else {
        return runtime + ' / ' + averageTime + ' (' + percentage.toFixed(2) + ')';
      }
    }
  }

  calculateColor(runtime: string, averageTime: string): boolean {
    if (Number(averageTime) != 0) {
      if ((Number(runtime) / Number(averageTime) * 100) > 100) {
        return true;
      } else {
        return false;
      }
    }
  }


  getArticle(reference: string): void {
    this.articleService.getArticle(reference).subscribe(
      data => this.article = data,
      () => {
      },
      () => this.displayHelp = true);
  }


  // Converts timestamp to date format for table
  convertDate(timeStamp: Date): string {
    let date = moment(timeStamp);
    return date.format('DD/MM/YY - HH:mm:ss');
  }


  // ------------------------------------ Table restoration -----------------------------------

  // Restore table before jobDetails
  private restoreTable() {
    this.resource = this.sharedDataService.resource;
    this.resourceSelected(null);
    this.selectedLocation = this.sharedDataService.selectedLocation;
    this.filterLocation(null);
    this.locationDropDown.placeholder = this.sharedDataService.selectedLocation;
    this.selectedStartDate = this.sharedDataService.selectedStartDate;
    this.selectedStatus = this.sharedDataService.selectedStatus;
    this.selectedAppFullName = this.sharedDataService.selectedAppFullName;
    this.dtTable.rows = this.sharedDataService.tableEvent.rows;
    // Load Jobs with past filters
    this.loadJobsLazy(this.sharedDataService.tableEvent);
    // Gets page where user was before
    this.firstOnTable = this.sharedDataService.tableEvent.first;
  }


  // Refresh Data on table
  refreshTable() {
    this.authorizationService.checkLogin();
    this.loadJobsLazy(this.sharedDataService.tableEvent);
  }


  resetMultiselect() {
    this.multiselect.ngOnInit();
    this.multiselect.hide();
    this.multiselectTwo.ngOnInit();
    this.multiselectTwo.hide();
  }

  // CSV export for all pages
  exportCsv() {
    setTimeout(() => {
      this.jobCall(0, this.totalRecords, true);
      this.loadingExport = false;
    });
  }

  //DOWNLOAD
  download() {
    setTimeout(() => {
      let csvData = this.ConvertToCSV(this.csvJobs);

      let a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      let blob = new Blob([csvData], { type: 'text/csv' });
      let url = window.URL.createObjectURL(blob);
      a.href = url;
      let x: Date = new Date();
      // File name
      let link: string = 'download' + x.getMonth() + '_' + x.getDay() + '.csv';
      a.download = link.toLocaleLowerCase();
      a.click();
    });
  }


  // convert Json to CSV data in Angular2
  ConvertToCSV(objArray) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = '';

    for (let index in objArray[0]) {
      // convert each value to string and separate it by comma
      row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in array[i]) {
        if (line != '') {
          line += ',';
        }

        line += array[i][index];
      }
      str += line + '\r\n';
    }
    // remove modal dialog
    this.display = !this.display;
    this.loadingExport = true;
    return str;
  }


}
